/* Bella K Relaunch: Produktseite (bkr-main-product).
   Kaufkasten: Preise live aus den Produktdaten (JSON in der Section, Beträge in Cent), Abo über Selling Plans,
   Add-ons, Menge, Warenkorb als items[]-Formular. Galerie (Swipe + Thumbs), Sticky-Kaufleiste.
   Ohne JS funktioniert der Einmalkauf über die nativen Felder id/quantity. */
window.bkr.section('.s-main-product', function (root) {
  var $ = window.bkr.$;
  var $$ = window.bkr.$$;
  var d = document;
  var reduce = window.bkr.reduce;
  var undo = [];
  function on(el, ev, fn, opt) { el.addEventListener(ev, fn, opt); undo.push(function () { el.removeEventListener(ev, fn, opt); }); }

  /* ------------------------------------------------------------ Galerie */
  var gal = $('[data-gallery]', root);
  if (gal) {
    var track = $('.gal__track', gal);
    var slides = $$('.gal__slide', gal);
    var thumbs = $$('.gal__thumb', gal);
    var counter = $('[data-gal-current]', gal);
    var current = 0;
    var mark = function (i) {
      if (i === current || i < 0 || i >= slides.length) return;
      current = i;
      if (counter) counter.textContent = String(i + 1);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      var th = thumbs[i];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    };
    var go = function (i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    };
    on(gal, 'click', function (ev) {
      var t = ev.target.closest('.gal__thumb');
      if (t) go(thumbs.indexOf(t));
    });
    var raf = 0;
    on(track, 'scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { if (track.clientWidth) mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    on(track, 'keydown', function (ev) {
      if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
      if (track.scrollWidth <= track.clientWidth) return; // Desktop-Raster: nichts zu blättern
      ev.preventDefault();
      go(Math.max(0, Math.min(slides.length - 1, current + (ev.key === 'ArrowRight' ? 1 : -1))));
    });
    undo.push(function () { cancelAnimationFrame(raf); });
  }

  // Theme-Editor: gewählten Block zeigen (Galeriebild ansteuern, Akkordeon öffnen)
  on(d, 'shopify:block:select', function (ev) {
    if (!root.contains(ev.target)) return;
    var sl = ev.target.closest && ev.target.closest('.gal__slide');
    if (sl && gal) {
      var all = $$('.gal__slide', gal);
      var track2 = $('.gal__track', gal);
      if (track2 && track2.scrollWidth > track2.clientWidth) track2.scrollTo({ left: sl.offsetLeft - all[0].offsetLeft });
    }
    if (ev.target.matches && ev.target.matches('details.acc')) ev.target.open = true;
  });

  /* ------------------------------------------------------------ Kaufkasten */
  var form = $('form[data-buy]', root);
  var dataEl = $('[data-product-json]', root);
  var D = null;
  try { D = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { D = null; }

  if (form && D && D.variants && D.variants.length) {
    var NBSP = ' ';
    var price = $('[data-price]', form);
    var compare = $('[data-compare]', form);
    var save = $('[data-save]', form);
    var unit = $('[data-unit]', form);
    var perday = $('[data-perday]', form);
    var once = $('[data-once]', form);
    var onceDay = $('[data-onceday]', form);
    var subEl = $('[data-subprice]', form);
    var subDay = $('[data-subday]', form);
    var subTag = $('[data-sub-tag]', form);
    var interval = $('[data-interval]', form);
    var planSelect = $('[data-plan-select]', form);
    var qtyInput = $('.qty__input', form);
    var qtyMinus = $('[data-qty="-1"]', form);
    var qtyPlus = $('[data-qty="1"]', form);
    var QMIN = (qtyInput && parseInt(qtyInput.min, 10)) || 1;
    var QMAX = (qtyInput && parseInt(qtyInput.max, 10)) || 10;
    var soldOutLabel = D.soldOutLabel || 'Ausverkauft';
    var atcBtn = $('[data-main-atc]', form);
    var atcLabel = $('[data-atc-label]', form);
    var atcPrice = $('[data-atc-price]', form);
    var atcSep = $('.btn__sep', form);
    var itemsBox = $('[data-items]', form);
    var sticky = $('[data-sticky-atc]', root);
    var stickyVariant = sticky && $('[data-sticky-variant]', sticky);
    var stickyBtn = sticky && $('[data-sticky-btn]', sticky);

    // Wie in der Section (money_without_currency + &nbsp;€): Zahlformat aus dem Shop-Format, Euro dahinter, also „23,00 €“
    var money = function (cents) {
      var m = String(D.moneyFormat || '').match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount_with_comma_separator';
      var n = Math.round(cents);
      var f = function (prec, th, dec) {
        var s = (n / 100).toFixed(prec).split('.');
        var i = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
        return s[1] ? i + dec + s[1] : i;
      };
      var v;
      switch (key) {
        case 'amount_no_decimals': v = f(0, ',', '.'); break;
        case 'amount_with_comma_separator': v = f(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = f(0, '.', ','); break;
        case 'amount_with_apostrophe_separator': v = f(2, '\'', '.'); break;
        case 'amount_no_decimals_with_space_separator': v = f(0, ' ', ','); break;
        case 'amount_with_space_separator': v = f(2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': v = f(2, ' ', '.'); break;
        default: v = f(2, ',', '.');
      }
      return v + NBSP + '€';
    };

    var byId = {};
    D.variants.forEach(function (v) { byId[String(v.id)] = v; });
    var portions = D.portions || 30;
    var grams = D.grams || 150;
    var perDay = function (cents, v) { return money(Math.round(cents / (v.bags * portions))); };
    var perKg = function (cents, v) { return money(Math.round(cents * 1000 / (v.bags * grams))) + ' / kg'; };
    var pct = function (part, whole) { return whole > 0 ? Math.round((1 - part / whole) * 100) : 0; };

    // Preis einer Variante für die gewählte Kaufart (Abo: Allocation des gewählten Plans, sonst Einzelpreis)
    var priceOf = function (v, sub, planId) {
      var a = sub && planId && v.plans ? v.plans[String(planId)] : null;
      if (a) return { price: a.price, delivery: a.delivery || a.price, was: v.price > a.price ? v.price : 0, plan: true };
      return { price: v.price, delivery: v.price, was: v.compare > v.price ? v.compare : 0, plan: false };
    };

    var variantRadios = $$('input[name="id"]', form);
    var planRadios = $$('[data-plan-radio]', form);
    var addonInputs = $$('[data-addon]', form);

    var state = function () {
      var checked = $('input[name="id"]:checked', form) || variantRadios[0];
      var v = (checked && byId[String(checked.value)]) || D.variants[0];
      var planR = $('[data-plan-radio]:checked', form);
      var sub = !!(planR && planR.value === 'sub' && planSelect && planSelect.value);
      var q = qtyInput ? Math.max(QMIN, Math.min(QMAX, parseInt(qtyInput.value, 10) || QMIN)) : 1;
      var addons = addonInputs.filter(function (i) { return i.checked && (!i.disabled || i.hasAttribute('data-gift-on')); }).map(function (i) {
        var gift = i.hasAttribute('data-gift-on');
        return { id: i.value, price: gift ? 0 : (parseInt(i.getAttribute('data-addon-price'), 10) || 0), name: i.getAttribute('data-addon-name') || '', gift: gift ? (i.getAttribute('data-gift-prop') || 'abo3') : '' };
      });
      return { v: v, sub: sub, planId: sub ? planSelect.value : null, q: q, addons: addons };
    };

    var setText = function (el, txt) { if (el && el.textContent !== txt) el.textContent = txt; };
    var hide = function (el, h) { if (el) el.hidden = !!h; };
    var addHidden = function (name, value) {
      var i = d.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = String(value);
      itemsBox.appendChild(i);
    };

    // Abo-Intervall je Menge (PAULs plan_map: Varianten-ID -> Selling-Plan-ID)
    var planMap = {};
    try { planMap = D.planMap ? JSON.parse(D.planMap) : {}; } catch (e) { planMap = {}; }
    var lastPlanVariant = null;
    var applyPlanMap = function () {
      if (!planSelect) return;
      var checked = $('input[name="id"]:checked', form) || variantRadios[0];
      var vid = checked ? String(checked.value) : '';
      if (vid === lastPlanVariant) return;
      lastPlanVariant = vid;
      var pid = planMap[vid];
      if (pid && $('option[value="' + pid + '"]', planSelect)) planSelect.value = String(pid);
    };

    // Gratis-Add-on (Löffel) bei X Beuteln im Abo: gesetzt, gesperrt, Preis 0, Merkmal _bk_geschenk
    var applyGift = function () {
      var checked = $('input[name="id"]:checked', form) || variantRadios[0];
      var v = (checked && byId[String(checked.value)]) || D.variants[0];
      var planR = $('[data-plan-radio]:checked', form);
      var sub = !!(planR && planR.value === 'sub' && planSelect && planSelect.value);
      addonInputs.forEach(function (i) {
        var bags = parseInt(i.getAttribute('data-gift-bags'), 10) || 0;
        if (!bags) return;
        var on = sub && v && v.bags >= bags;
        var card = i.closest('.opt__card');
        var was = i.hasAttribute('data-gift-on');
        if (on && !was) { i.setAttribute('data-gift-on', ''); i.setAttribute('data-was-checked', i.checked ? '1' : ''); i.checked = true; i.disabled = true; }
        if (!on && was) { i.removeAttribute('data-gift-on'); i.disabled = false; i.checked = i.getAttribute('data-was-checked') === '1'; }
        if (card) {
          card.classList.toggle('is-gift', on);
          $$('[data-addon-giftprice], [data-addon-gifttext]', card).forEach(function (el) { el.hidden = !on; });
          $$('[data-addon-paid], [data-addon-text]', card).forEach(function (el) { el.hidden = on; });
        }
      });
    };

    var render = function () {
      applyPlanMap();
      applyGift();
      var s = state();
      var p = priceOf(s.v, s.sub, s.planId);
      var extras = s.addons.reduce(function (sum, a) { return sum + a.price; }, 0);
      var total = p.price * s.q + extras;

      setText(price, money(p.price));
      if (compare) { hide(compare, !p.was); setText(compare, p.was ? money(p.was) : ''); }
      var planPct = p.plan ? pct(p.price, s.v.price) : 0;
      if (save) { hide(save, !(s.sub && planPct > 0)); setText(save, '−' + planPct + NBSP + '%'); }
      setText(unit, perKg(p.delivery, s.v));
      setText(perday, perDay(p.delivery, s.v));

      // Kaufart-Karten folgen der gewählten Menge
      setText(once, money(s.v.price));
      setText(onceDay, perDay(s.v.price, s.v));
      if (planSelect) {
        var sp = priceOf(s.v, true, planSelect.value);
        setText(subEl, money(sp.price));
        setText(subDay, perDay(sp.delivery, s.v));
        var subPct = sp.plan ? pct(sp.price, s.v.price) : 0;
        if (subTag) { hide(subTag, !(subPct > 0)); setText(subTag, '−' + subPct + NBSP + '%'); }
      }
      hide(interval, !s.sub);

      // Mengenkarten: Preis, Streichpreis, Grundpreis, Tagespreis, ehrliche Ersparnis
      variantRadios.forEach(function (inp) {
        var lab = inp.closest('.opt__card'); if (!lab) return;
        var v = byId[String(inp.value)]; if (!v) return;
        var vp = priceOf(v, s.sub, s.planId);
        setText($('[data-c-price]', lab), (v.bags * portions) + ' Portionen · ' + money(vp.price));
        var was = $('[data-c-was]', lab);
        if (was) { hide(was, !vp.was); setText(was, vp.was ? money(vp.was) : ''); }
        setText($('[data-c-kg]', lab), 'Grundpreis ' + perKg(vp.delivery, v));
        setText($('[data-c-day]', lab), perDay(vp.delivery, v));
        var tg = $('.tag--save', lab);
        if (tg) {
          var sv = D.showSave && D.refPrice ? pct(vp.price, v.bags * D.refPrice) : 0;
          hide(tg, !(sv > 0));
          setText(tg, 'Spare ' + sv + NBSP + '%');
        }
      });

      // Button und Summe
      var avail = !!s.v.available;
      if (atcBtn) atcBtn.disabled = !avail;
      setText(atcLabel, avail ? (D.atcLabel || 'In den Warenkorb') : soldOutLabel);
      hide(atcSep, !avail);
      hide(atcPrice, !avail);
      setText(atcPrice, money(total));
      if (qtyInput && String(qtyInput.value) !== String(s.q)) qtyInput.value = s.q;
      // Stepper an den Grenzen sperren (aria-disabled statt disabled, damit der Tastaturfokus auf dem Button bleibt)
      if (qtyMinus) qtyMinus.setAttribute('aria-disabled', String(s.q <= QMIN));
      if (qtyPlus) qtyPlus.setAttribute('aria-disabled', String(s.q >= QMAX));

      // Warenkorb-Felder: items[0] = Produkt (+ Selling Plan), danach die Add-ons
      if (itemsBox) {
        itemsBox.textContent = '';
        addHidden('items[0][id]', s.v.id);
        addHidden('items[0][quantity]', s.q);
        if (s.sub && p.plan) addHidden('items[0][selling_plan]', s.planId);
        s.addons.forEach(function (a, k) {
          addHidden('items[' + (k + 1) + '][id]', a.id);
          addHidden('items[' + (k + 1) + '][quantity]', 1);
          if (a.gift) addHidden('items[' + (k + 1) + '][properties][_bk_geschenk]', a.gift);
        });
      }

      // Sticky-Kaufleiste
      if (stickyVariant) {
        var name = D.defaultOnly ? '' : s.v.title;
        var line = (s.q > 1 ? s.q + ' × ' : '') + name + s.addons.map(function (a) { return ' + ' + a.name + (a.gift ? ' (gratis)' : ''); }).join('');
        setText(stickyVariant, (line ? line + ' · ' : '') + money(total));
      }
      if (stickyBtn) { stickyBtn.disabled = !avail; setText(stickyBtn, avail ? (D.atcLabel || 'In den Warenkorb') : soldOutLabel); }
      return s;
    };

    // Vorauswahl: ?variant= (Shopify, schon serverseitig gesetzt) hat Vorrang vor ?menge=; ?abo=1 wählt das Abo.
    var qs = new URLSearchParams(window.location.search);
    if (!qs.get('variant')) {
      var bags = parseInt(qs.get('menge'), 10);
      if (bags) {
        var same = D.variants.filter(function (v) { return v.bags === bags; });
        var match = same.filter(function (v) { return v.available; })[0] || same[0]; // ausverkauft: trotzdem zeigen, Button bleibt gesperrt
        var radio = match && variantRadios.filter(function (r) { return String(r.value) === String(match.id); })[0];
        if (radio) radio.checked = true;
      }
    }
    if (qs.get('abo') === '1') {
      var subR = planRadios.filter(function (r) { return r.value === 'sub'; })[0];
      if (subR) subR.checked = true;
    }

    var lastVariant = null;
    var update = function () {
      var s = render();
      // URL wie in Dawn mitführen (?variant=), damit Teilen und Neuladen die Auswahl behalten
      if (lastVariant !== null && lastVariant !== s.v.id && !window.bkr.design && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', s.v.id);
        u.searchParams.delete('menge');
        history.replaceState(history.state, '', u.toString());
      }
      lastVariant = s.v.id;
    };

    on(form, 'change', update);
    if (qtyInput) on(qtyInput, 'input', function () { if (qtyInput.value !== '') update(); });
    $$('[data-qty]', form).forEach(function (b) {
      on(b, 'click', function () {
        qtyInput.value = Math.max(QMIN, Math.min(QMAX, (parseInt(qtyInput.value, 10) || QMIN) + parseInt(b.getAttribute('data-qty'), 10)));
        update();
      });
    });

    // Beim Absenden zählen nur die items[]-Felder: native Felder kurz deaktivieren (nicht mitgesendet).
    // Seal Subscriptions hängt sein eigenes Widget (inkl. selling_plan-Feld) in jedes Produktformular.
    // Unsere Kaufart ersetzt es; seine Felder werden deshalb nie mitgesendet (Widget ist per CSS ausgeblendet).
    var foreignFields = function () { return $$('.sealsubs-container input, .sealsubs-container select, .sealsubs-target-element input, .sealsubs-target-element select, input[name="selling_plan"]', form); };
    var offFields = function () { return variantRadios.concat(planRadios, qtyInput ? [qtyInput] : [], foreignFields()); };
    on(form, 'submit', function (ev) {
      var s = render();
      if (!s.v.available) { ev.preventDefault(); return; }
      offFields().forEach(function (el) {
        if (!el.disabled) { el.disabled = true; el.setAttribute('data-bkr-off', ''); }
      });
    });
    // Zurück-Navigation (bfcache): Felder wieder freigeben
    on(window, 'pageshow', function () {
      $$('[data-bkr-off]', form).forEach(function (el) { el.disabled = false; el.removeAttribute('data-bkr-off'); });
      update();
    });

    update();

    /* ---------------------------------------------------------- Sticky-Kaufleiste */
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-shown', past);
        sticky.setAttribute('aria-hidden', String(!past));
        if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
      });
      io.observe(atcBtn);
      undo.push(function () { io.disconnect(); });
    }
  }

  return function () { undo.forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } }); };
});
